import Api from '@/api/api.js'

export default {
    checkIfPatientEstAssure(patient_id) {
        const promise = Api().get('/assurances/patient/'+patient_id+'/est_assure')
        return promise.then(response => response.data)
    },

    getPatientInfoAssurance(data) {
        const promise = Api().get('/assurances/patient/'+data.patient_id+'/info_assurance')
        return promise.then(response => response.data)
    },

    getPrixPrestationAssur(data) {
        const promise = Api().get('/parametres/prix/injectable/'+data.patient_id+'/'+data.injectable_id)
        return promise.then(response => response.data)
    },

    addAssurance(data) {
        const promise = Api().post('/assurances/store', data)
        return promise.then((response) => response.data)
    },

    getAssurance() {
        const promise = Api().get('/assurances')
        return promise.then(response => response.data)
    },

    deleteCompagnie(data) {
        const promise = Api().put('/assurances/delete', data)
        return promise.then((response) => response.data)
    },
    
    getAssuranceById(assurance_id) {
        const promise = Api().get('/assurances/show/'+assurance_id)
        return promise.then(response => response.data)
    },

    importerSouscripteur(assurance_id, user_id, data, medicaments) {
        const promise = Api().post('/assurances/souscripteurs/'+assurance_id+'/'+user_id+'/importer', data, medicaments)
        return promise.then((response) => response.data)
    },

    saveSouscripteur(data) {
        const promise = Api().post('/assurances/souscripteurs/store', data)
        return promise.then((response) => response.data)
    },

    listeSouscripteur(assurance_id) {
        const promise = Api().get('/assurances/'+assurance_id+'/souscripteurs/liste')
        return promise.then((response) => response.data)
    },

    deleteSouscripteur(data) {
        const promise = Api().put('/assurances/souscripteurs/'+data.souscripteur_id+'/delete')
        return promise.then((response) => response.data)
    },

    getSouscripteurById(data) {
        const promise = Api().get('/assurances/'+data.assurance_id+'/souscripteurs/'+data.souscripteur_id)
        return promise.then((response) => response.data)
    },

    listeAllPrestationSouscripteur(data) {
        const promise = Api().get('/assurances/'+data.assurance_id+'/souscripteurs/'+data.souscripteur_id+'/prestations')
        return promise.then((response) => response.data)
    },

    listePrestationSouscripteur(data) {
        const promise = Api().get('/assurances/'+data.assurance_id+'/souscripteurs/'+data.souscripteur_id+'/prestations/'+data.est_exclu)
        return promise.then((response) => response.data)
    },

    updatePrestation(assurance_id, souscripteur_id, data) {
        const promise = Api().put('/assurances/'+assurance_id+'/souscripteurs/'+souscripteur_id+'/prestations', data)
        return promise.then((response) => response.data)
    },

    listeAllMedCategorieSouscripteur(data) {
        const promise = Api().get('/assurances/'+data.assurance_id+'/souscripteurs/'+data.souscripteur_id+'/categorie_meds')
        return promise.then((response) => response.data)
    },

    listeMedCategorieSouscripteur(data) {
        const promise = Api().get('/assurances/'+data.assurance_id+'/souscripteurs/'+data.souscripteur_id+'/categorie_meds/'+data.est_exclu)
        return promise.then((response) => response.data)
    },

    listeAnalyseSouscripteur(data) {
        const promise = Api().get('/assurances/'+data.assurance_id+'/souscripteurs/'+data.souscripteur_id+'/analyses')
        return promise.then((response) => response.data)
    },

    updateAnalyse(assurance_id, souscripteur_id, data) {
        const promise = Api().put('/assurances/'+assurance_id+'/souscripteurs/'+souscripteur_id+'/analyses', data)
        return promise.then((response) => response.data)
    },

    addGroupeAssurance(data) {
        const promise = Api().post('/assurances/groupes/store', data)
        return promise.then((response) => response.data)
    },

    getGroupeAssurance() {
        const promise = Api().get('/assurances/groupes')
        return promise.then(response => response.data)
    },

    deleteGroupeAssurance(data) {
        const promise = Api().put('/assurances/groupes/delete', data)
        return promise.then((response) => response.data)
    },

    getGroupeAssuranceById(groupe_id) {
        const promise = Api().get('/assurances/groupes/'+groupe_id)
        return promise.then(response => response.data)
    },

    getAssuranceSansGroupe() {
        const promise = Api().get('/assurances/sans_groupe')
        return promise.then(response => response.data)
    },

    configBaseActifAssurance(data) {
        const promise = Api().put('/assurances/groupes/config/type_config/'+data.type_config+'/'+data.groupe_id)
        return promise.then((response) => response.data)
    },

    getTousTypeConsultations() {
        const promise = Api().get('/parametres/consultations')
        return promise.then(response => response.data)
    },

    getCategorieMedicament() {
        const promise = Api().get('/parametres/medicaments/categorie')
        return promise.then(response => response.data)
    },

    getMedicamentList() {
        const promise = Api().get('/parametres/medicaments')
        return promise.then(response => response.data)
    },

    setExclusion(data) {
        const promise = Api().post('/parametres/prestations/exclusions/store', data)
        return promise.then(response => response.data)
    },

    getListExclusByPrestation(data) {
        const promise = Api().get('/parametres/prestations/'+data.type_prestation+'/assurance/'+data.assurance_id+'/souscripteur/'+data.souscripteur_id+'/exclusions')
        return promise.then(response => response.data)
    },

    assignGroupToAssurance(data) {
        const promise = Api().put('/groupes/groupe_assurance/assign/assurance', data)
        return promise.then(response => response.data)
    },

    getAssignedExamensToUsers(data){
        const promise = Api().post('/parametres/examens/managers',data)
        return promise.then(response => response.data)
    },
    
    assignExamensToUsers(user_id,data){
        const promise = Api().post('/parametres/examens/managers/'+user_id+'/assign',data)
        return promise.then(response => response.data)
    },

    getConfigInfoClinique(data){
        const promise = Api().get('/config/info_clinique/'+data)
        return promise.then(response => response.data)
    },

    getListeAllBonConsommable(){
        const promise = Api().get('/config/bon_consommable/liste')
        return promise.then(response => response.data)
    },

    saveConfigInfoClinique(data){
        const promise = Api().post('/config/info_clinique/store', data)
        return promise.then(response => response.data)
    },

    saveConsommableBonVisibilite(data){
        const promise = Api().post('/config/bon_consommable/type_consultation/store', data)
        return promise.then(response => response.data)
    },

    saveChirurgie(data){
        const promise = Api().post('/config/chirurgie/store', data)
        return promise.then(response => response.data)
    },

    saveKChirurgie(data){
        const promise = Api().post('/config/k_chirurgie/store', data)
        return promise.then(response => response.data)
    },

    getListeChirurgies(){
        const promise = Api().get('/config/chirurgies')
        return promise.then(response => response.data)
    },

    deleteItem(data){
        const promise = Api().post('/config/item/delete', data)
        return promise.then(response => response.data)
    },

    saveBilanSante(data){
        const promise = Api().post('/bilan-sante', data)
        return promise.then(response => response.data)
    },

    getListeBilanSante(){
        const promise = Api().get('/bilan-sante/liste')
        return promise.then(response => response.data)
    },

    deleteBilanSante(data){
        const promise = Api().post('/bilan-sante/delete', data)
        return promise.then(response => response.data)
    },

    getConsumableOfConsultation(data){
        const promise = Api().post('/config/consumables', data)
        return promise.then(response => response.data)
    },

    saveConsumableOfConsultation(data){
        const promise = Api().post('/config/consumables/add', data)
        return promise.then(response => response.data)
    },

    deleteConsumableOfConsultation(data){
        const promise = Api().post('/config/consumables/delete', data)
        return promise.then(response => response.data)
    },

    getListeTypeAdmission(data_type){
        const promise = Api().get('/parametres/admissions/'+data_type+'/liste')
        return promise.then(response => response.data)
    },

    storeAdmission(data){
        const promise = Api().post('/parametres/admissions/store', data)
        return promise.then(response => response.data)
    },

    deleteAdmissionByType(data){
        const promise = Api().post('/parametres/type-admissions/delete', data)
        return promise.then(response => response.data)
    },

    importAnalyse(data){
        const promise = Api().post('/parametres/importer/analyse', data)
        return promise.then(response => response.data)
    },

    importPrestation(data){
        const promise = Api().post('/parametres/importer/prestations', data)
        return promise.then(response => response.data)
    },

    getDifferentialComputing() {
        const promise = Api().get('/consultations/calcul-differentiel')
        return promise.then(response => response.data)
    },

    getCountDown() {
        const promise = Api().get('/countdown')
        return promise.then(response => response.data)
    },

    storeConfigHistorique(data){
        const promise = Api().post('/config/historique/store', data)
        return promise.then(response => response.data)
    },

    getHistoriqueConfig(data){
        const promise = Api().post('/config/get-historique', data)
        return promise.then(response => response.data)
    },

    getListeSectionAntecedents() {
        const promise = Api().post('/antecedents/liste')
        return promise.then((response) => response.data)
    },

    saveSectionAntecedents(data) {
        const promise = Api().post('/antecedents/section/store', data)
        return promise.then((response) => response.data)
    },

    reorderSectionAntecedents(data) {
        const promise = Api().post('/antecedents/section/reorder', data)
        return promise.then((response) => response.data)
    },

    deactivateATCDPatient(data) {
        const promise = Api().post('/antecedents/section/deactivate', data)
        return promise.then((response) => response.data)
    },

    saveModeleExamen(data) {
        const promise = Api().post('/model-examens/store', data)
        return promise.then((response) => response.data)
    },

    getListeModeleExamens(data) {
        const promise = Api().post('/model-examens/liste', data)
        return promise.then((response) => response.data)
    },

    getListeChampByModeleExamen(data) {
        const promise = Api().post('/model-examens/liste-champs', data)
        return promise.then((response) => response.data)
    },

    saveTriUrgence(data) {
        const promise = Api().post('/config/store-tri-urgence', data)
        return promise.then((response) => response.data)
    },

    getTriUrgence() {
        const promise = Api().get('/config/liste/tri-urgence')
        return promise.then((response) => response.data)
    },

    reOrderTriUrgence(data) {
        const promise = Api().post('/config/reorder/tri-urgence', data)
        return promise.then((response) => response.data)
    },

    deleteTriUrgence(data) {
        const promise = Api().post('/config/delete/tri-urgence', data)
        return promise.then((response) => response.data)
    },

    deleteLits(data) {
        const promise = Api().post('/parametres/lits/delete', data)
        return promise.then((response) => response.data)
    },

    saveLit(data) {
        const promise = Api().post('/parametres/lit/store', data)
        return promise.then((response) => response.data)
    },

    getListeOccurencesByChamp(data) {
        const promise = Api().post('/champs/occurences-by-champ', data)
        return promise.then((response) => response.data)
    },
}